import { fontWeightStrong } from '@atlas-frontend/design-tokens';
import styled from 'styled-components';

export const BlackString = styled.span`
  font-weight: ${fontWeightStrong};
`;
